import axios from '../utils/axios';

export async function fetchWorkdayStatus() {
    const res = await axios.get('/workday/status');
    return res.data?.data || null;
}

export async function fetchDelayReasons() {
    const res = await axios.get('/workday/delay-reasons');
    return res.data?.data?.reasons || [];
}

export async function completePendingCheckout({ reason, remarks, location } = {}) {
    const res = await axios.post('/workday/pending-checkout', {
        reason,
        remarks,
        ...(location ? { location } : {}),
    });
    return res.data?.data || null;
}

export async function workdayCheckIn(location) {
    const res = await axios.post('/workday/check-in', location ? { location } : {});
    return res.data?.data || null;
}

export async function fetchWorkingDistributor() {
    const res = await axios.get('/workday/working-distributor');
    return res.data?.data || null;
}

export async function selectWorkingDistributor(distributorId, reason = null) {
    const res = await axios.post('/workday/working-distributor/select', {
        distributorId,
        ...(reason ? { reason } : {}),
    });
    return res.data?.data || null;
}

export async function fetchWorkingDistributorHistory() {
    const res = await axios.get('/workday/working-distributor/history');
    return res.data?.data?.sessions || [];
}
